import { makeStyles, useTheme } from '@material-ui/core/styles';

export const SHOWROOM_LAYOUT_HEADER_HEIGHT = 49;

export const Theme = useTheme;
export const useStyles = makeStyles(() => {
	return ({
		loadingContainer: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			height: '100%'
		},
		dialogTitle: {
			paddingBottom: 0,
			marginBottom: 0,
			padding: 0
		},
		dialogContent: {
			padding:0,
			position: 'relative',
			zIndex: 0
		},
		LayoutHeader: {
			backgroundColor: 'white',
			height: SHOWROOM_LAYOUT_HEADER_HEIGHT
		},
		LayoutHeaderToolbar: {
			paddingLeft: 50,
			paddingRight: 50,
			justifyContent: 'space-between',
			minHeight: 49
		},
		LayoutHeaderShowroomNameContainer: {
			display: 'flex',
			alignItems: 'center'
		},
		LayoutHeaderBackButton: {
			fontSize: 18
		},
		LayoutHeaderShowroomName: {
			fontSize: 22,
			fontWeight: 600,
			marginLeft: 15
		},
		LayoutHeaderActionsContainer: {
			display: 'flex'
		},
		LayoutHeaderActionButton: {
			borderRadius: 3,
			padding: '5px 15px',
			margin: '0 5px'
		},
		LayoutHeaderButtonLabel: {
			fontSize: 14,
			fontWeight: 500
		},
		LayoutHeaderButtonIcon: {
			'& > *:first-child': {
				fontSize: 16
			}
		},
		LayoutHeaderTabsContainer: {
			display: "flex"
		},
		tabDivider: {
			height: 15,
			margin: "0 10px",
			alignSelf: "center"
		},
		LayoutHeaderTab: {
			textTransform: "none", 
			maxWidth: 100
		}
	});
});
